

import React, { memo } from 'react';
import cx from 'classnames';
import Text from '../../Text';
import '../styles/_tab.scss';










function Tab({ title, isSelected, onClick, className, activeBorderPosition = 'top', isV2Design = false }) {
  const prefix = isV2Design ? 'tab-v2' : 'tab';
  return (
    <button
      type="button"
      className={
      cx(prefix,
      { [`${prefix}--selected`]: isSelected },
      { [`${className}__${prefix}`]: className },
      { [`${className}__${prefix}--selected`]: className && isSelected },
      { [`${prefix}__${activeBorderPosition}`]: activeBorderPosition }
      )}
      onClick={!isSelected ? onClick : void 0}>

      <Text noMargin button={isSelected}>{title}</Text>
    </button>);

}

export default memo(Tab);